import React from 'react';
import SectionHeader from './SectionHeader';
import { Reveal } from './ScrollReveal';

export default function Circles() {
  const circles = [
    { num: "Kreis 01", title: "GF & C-Level", body: "Führungskräfte, die die Einsamkeit an der Spitze kennen. Entscheidungen, die sie mit niemandem intern besprechen können — hier besprechen sie sie." },
    { num: "Kreis 02", title: "Gründer & Startups", body: "Gründer, die schnell in Führungsrollen gewachsen sind. Der Job ist plötzlich mehr Führung als Produkt — hier sitzen Menschen, die dasselbe gerade durchleben." },
    { num: "Kreis 03", title: "Solopreneure", body: "Selbstständige, die alle Entscheidungen allein treffen. Hier sitzen vier Menschen, die das kennen — und kein Konkurrent ist dabei." }
  ];

  return (
    <section id="kreis" className="py-32 relative z-10 border-t border-brand-border">
      <div className="max-w-[1100px] mx-auto px-8">
        <SectionHeader 
          num="04" 
          eyebrow="Die drei Kreise" 
          title="3 Gruppen × 4 Mitglieder<br/>=<em class='not-italic italic text-brand-gold'>12 Partner.</em> Nie mehr." 
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-[1px] bg-brand-border border-2 border-brand-border mb-20 shadow-2xl">
          {circles.map((circle, idx) => (
            <Reveal key={idx} delay={idx * 0.1}>
              <div className="bg-brand-dark p-12 transition-colors duration-300 hover:bg-brand-surface h-full">
                <div className="text-[0.9rem] font-bold text-brand-gold tracking-[0.2em] uppercase mb-4">{circle.num}</div>
                <div className="font-serif text-[1.7rem] font-normal text-brand-white mb-4">{circle.title}</div>
                <div className="flex items-center gap-3 mb-6">
                  <span className="text-[2.5rem] font-serif font-light text-brand-gold leading-none">4</span>
                  <span className="text-[0.75rem] text-brand-muted font-bold tracking-widest uppercase">Mitglieder max.</span>
                </div>
                <div className="text-[1rem] text-brand-muted leading-relaxed font-light">{circle.body}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}